export default "__VITE_ASSET__CiGhkbyR__"